import React from 'react';
import BasicDropDownPage from './basic-drop-down-page';
import DropDownListPage from '@pages-clean/dummy-page/pages/drop-down-list-page';
import Inputs from '@pages-clean/dummy-page/pages/inputs';
import MultiSelectPage from '@pages-clean/dummy-page/pages/multi-select-page';

interface InputsPageProps {
    isDisabled: boolean;
}

const InputsPage = ({ isDisabled }: InputsPageProps) => {
    return (
        <div className="k-d-flex k-justify-content-between k-gap-4">
            <div className="!k-flex-basis-1/3">
                <Inputs isDisabled={isDisabled} />
            </div>
            <div className="!k-flex-basis-1/3">
                <DropDownListPage isDisabled={isDisabled} />
            </div>
            <div className="!k-flex-basis-1/3">
                <BasicDropDownPage isDisabled={isDisabled} />
                <br />
                <MultiSelectPage isDisabled={isDisabled} />
            </div>
        </div>
    );
};

export default InputsPage;
